import { useMemo } from 'react';

import { seriesColor, StackedBarChart, type StackedBarPoint } from '@/design-system/charts';
import type { AiUsageMonth } from '@/api/types';

interface CostTrendChartProps {
  months: readonly AiUsageMonth[];
}

const monthLabel = (epochMs: number): string =>
  new Date(epochMs).toLocaleString(undefined, { month: 'short', year: '2-digit', timeZone: 'UTC' });

/**
 * Stacked bar chart of monthly cost — Token $ at the bottom, DI $ on top.
 * Goes through the design-system `StackedBarChart` wrapper so axis
 * formatting and theming match the other charts in the hub.
 */
export function CostTrendChart({ months }: CostTrendChartProps) {
  const bars: StackedBarPoint[] = useMemo(
    () =>
      months.map((m) => ({
        x: monthLabel(m.monthStartMs),
        segments: [
          { name: 'Token $', value: m.tokenCostUsd, color: seriesColor(0) },
          { name: 'DI $', value: m.diCostUsd, color: seriesColor(2) },
        ],
      })),
    [months],
  );

  return <StackedBarChart bars={bars} unit="usd" chartTitle="Cost trend by month" />;
}
